import { Bell, ChevronRight, GraduationCap } from 'lucide-react';

import { Separator } from '@crossnokaye/ux-common';

import { AtlasRouteIds } from '@/components/navigation/constants';
import { NavLink } from '@/components/navigation/nav-link';
import { AlarmBar } from '@/components/navigation/top/components/alarm-bar';
import { EaiBadge } from '@/components/navigation/top/components/eai-badge';
import { ForcedIOBadge } from '@/components/navigation/top/components/forced-io-badge';

export const DesktopTopNav = ({
  orgName,
  facilityName,
  showEaiBadge,
}: {
  orgName: string;
  facilityName: string;
  showEaiBadge: boolean;
}) => {
  return (
    <div
      className={
        'mb-4 mx-5 flex flex-row items-center gap-4 border-b border-border min-h-[5.125rem] max-h-[5.125rem]'
      }
    >
      <div id={'breadcrumbs'} data-cy={'breadcrumbs'} className={'flex flex-row gap-2'}>
        <div className={'text-foreground'}>{orgName}</div>
        <ChevronRight
          className="glyph glyph-sm text-muted-foreground flex items-center justify-center ml-auto my-auto"
          aria-hidden="true"
        />
        <div className={'text-muted-foreground'}>{facilityName}</div>
      </div>
      <div id={'actions'} className={'flex flex-row ml-auto align-middle gap-4 items-center'}>
        <GraduationCap className="glyph glyph-lg flex items-center justify-center my-auto cursor-pointer" />
        <ForcedIOBadge label={'Forced I/O: '} />
        <Separator orientation={'vertical'} className={'w-[2px] bg-input !h-auto'} />
        <NavLink routeId={AtlasRouteIds.Alarms}>
          <Bell className="glyph glyph-lg flex items-center justify-center my-auto cursor-pointer" />
        </NavLink>
        <AlarmBar />
        {showEaiBadge && <EaiBadge />}
      </div>
    </div>
  );
};
